import { Heading, Box, Stack, Text, Flex, Button } from '@chakra-ui/react'

const Component = () => {
  return (
    <Flex flex={1}>
      <Stack textAlign="center" height="100%" width="100%" spacing={4} justifyContent="center">
        <Heading size="lg">403 Forbidden</Heading>
        <Text color="deepgray">アクセスしようとしたページは表示できません</Text>
        <Box>
          {/* next/link だと VPN 未接続時の prefetch で得た /403 リダイレクトがキャッシュされ遷移できないため、ハードナビゲーションにする */}
          <Button as="a" colorScheme="blue" variant="solid" href="/">
            TOP
          </Button>
        </Box>
      </Stack>
    </Flex>
  )
}

export default Component
